module.exports = __webpack_public_path__ + "img/sephiroth-min.60eae46e.png";